import styled from "@emotion/styled";
import { useWebChat } from "../../context";
import PhoneIcon from "../../icons/Phone";
import Refresh from "../../icons/Refresh";
import locales from '../../locales';


const Overlay = styled.div`
  position: absolute;
  top: 0;
  bottom: var(--chat-footer-height);
  left: 0;
  right: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.0);
  z-index: 10;
  height: auto !important;
  visibility: hidden;
  transition: all 200ms ease;
  transition-property: visibility, background-color;

  &.menu-open {
    background-color: rgba(0, 0, 0, 0.2);
    visibility: visible;
  }
`;

const StyledMenuButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 17px 21px;
  height: 40px;
  left: 24px;
  top: 16px;
  background: #FFFFFF;
  border-radius: 4px;
  width: 100%;
  border: 2px solid #FFFFFF;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  /* identical to box height, or 150% */
  display: flex;
  align-items: center;
  letter-spacing: -0.3px;

  color: #077AC0;

  span {
    padding-left: 16px;
  }
`;

const StyledNav = styled.nav`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 15;
  background-color: var(--color-primary-dark);
  display: flex;
  justify-content: center;
  border-radius: 16px 16px 0px 0px;
  margin-bottom: var(--chat-footer-height);
  min-height: 104px;

  transform: translateY(10%);
  opacity: 0;
  visibility: hidden;

  transition: all 200ms ease;
  transition-property: visibility, opacity, transform;

  &.menu-open {
    visibility: visible;
    opacity: 100;
    transform: translateY(0%);
  }

  ul  {
    padding: 0;
    padding-top: 16px;
    margin: 0;
    list-style: none;
    width: 100%;
    overflow: auto;
  }

  li {
    padding-top: 16px;
    padding-left: 24px;
    padding-right: 24px;
  }
`;


const Menu = () => {
  const { 
    closeMenu, 
    menuOpen, 
    reduxStore, 
    setReset, 
    setSpinnerDisplayed, 
    fetchToken,
    lang,
  } = useWebChat();

  const handleCallBlueCross = async () => {
    const { current } = reduxStore;

    current.dispatch({
      type: 'WEB_CHAT/SEND_EVENT',
      payload: {
        name: `resetconversation`,
      }
    });

    await new Promise(r => setTimeout(r, 50));

    current.dispatch({
      type: 'WEB_CHAT/SEND_EVENT',
      payload: {
        name: `phonehome`,
      }
    });

    closeMenu();
  }

  const handleRefresh = async () => {
    setReset(true);
    setSpinnerDisplayed(true);
    await fetchToken();
    setReset(false);
    setSpinnerDisplayed(false);
    closeMenu();
  }

  return (
    <>
      <Overlay className={menuOpen ? 'menu-open' : ''} onClick={closeMenu} />
      <StyledNav className={menuOpen ? 'menu-open' : ''}>
        <ul>
          <li>
            <StyledMenuButton onClick={handleRefresh}>
              <Refresh />
              <span>{locales(lang, 'reloadCTA')}</span>
            </StyledMenuButton>
          </li>
          <li>
            <StyledMenuButton onClick={handleCallBlueCross}>
              <PhoneIcon />
              <span>{locales(lang, 'callCTA')}</span>
            </StyledMenuButton>
          </li>
        </ul>
      </StyledNav>
    </>
  );
};

export default Menu;
